import { COMPANY_FILTER } from './filters.mapper';

export const companiesFormToConfiguration = ({ id, name, companyIds }) => ({
  id,
  name,
  filters: {
    [COMPANY_FILTER]: companyIds,
  },
});
